import React from 'react'
import ReactDOM from 'react-dom/client'

// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
// import {ReactQueryDevtools} from 'react-query/devtools'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'

setupAxios(axios)



Chart.register(...registerables)

const queryClient = new QueryClient()

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found')

const root = ReactDOM.createRoot(container)

// const status = err?.response?.status

// axios.interceptors.response.use(
//   (res) => {
//     if (typeof res.data === 'string' && res.data.includes('<!DOCTYPE html')) {
//       window.location.href = '/auth/login'
//       return Promise.reject(new Error('Session expired'))
//     }
//     return res
//   },
//   (err) => {
//     const status = err?.response?.status
//     if (status === 401) window.location.href = '/auth/login'
//     return Promise.reject(err)
//   }
// )
axios.interceptors.response.use(
  (res) => {

    // Check backend session expired response
    if (
      res?.data?.sessionExpired === true ||
      res?.data?.errorCode === 601
    ) {
      console.warn("Session expired. Redirecting to login...")

      // Clear any stored auth data
      localStorage.removeItem('auth')
      sessionStorage.clear()

      // Redirect to login page
      window.location.href = "/auth/login"

      return Promise.reject("Session expired")
      
    }

    return res
  },
  (err) => {
    // ✅ NETWORK ERROR (no response)
    if (!err?.response) {
      // Stop throwing runtime error UI by not rethrowing raw error in UI code
      console.warn('Network error (suppressed):', err?.message)

      // Option A: return a fake response to keep app running
      return Promise.resolve({
        data: { status: false, message: 'Network error', sessionExpired: false },
        status: 0,
        statusText: 'NETWORK_ERROR',
        headers: {},
        config: err.config,
      } as any)
    }

    // ✅ SESSION EXPIRED / UNAUTHORIZED
    const status = err.response.status
    const data = err.response.data

  // (err) => {
  //   const status = err?.response?.status

  //   if (status === 401) {
  //     window.location.href = "/auth/login"
  //   }

  //   return Promise.reject(err)
  // }
 if (status === 401 || data?.sessionExpired === true || data?.errorCode === 601) {
      window.location.replace('/auth/login')
      return Promise.reject(err)
    }

    return Promise.reject(err)
  }
)
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </MetronicI18nProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </React.StrictMode>
)